import React, { useEffect, useState } from "react";
import Header from "../../newinterface/header";
import Footer from "../../newinterface/footer";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { Progress, Spin, Tooltip } from "antd";
import PayMentForm from "./paymentForm";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
//const stripePromise = loadStripe("pk_test_LtdPg3j4qBGWzgnttRDiiz4g");
const stripePromise = loadStripe("pk_live_51D0cHSJ3Rr4TXUezDqWNIv2wR3dWKPfz24ZHwiLCcPoA5VUNiyWOp36sW8qlSLzgjovmaLt9XDzUbGn563gAm5U800umzJNYOH");
import {
  calculateBookingPrices,
  calculateTempInvoice,
  stayCalulation,
  totalFullStayAmount,
  mergeInvoicesByDaysLimit,
} from "./bookingCalculations";

function NewInstantReserveBook() {
  const [state, setState] = useState({
    buttonLoader: false,
    loading: false,
    loadingStatus: true,
    firstName: "",
    lastName: "",
    emailId: "",
    cardHolderName: "",
    corporateCode: "",
    phoneNo: "",
    notifyGuest: false,
    arrivalDate: null,
    arrivalTime: null,
    airline: "",
    flight: "",
    notes: "",
    checkin: null,
    checkout: null,
    countryCode: "+1",
    countrySymbol: "us",
    communityData: {},
    termsCheck: false,
    paymentMode: false,
    stripeToken: "",
    clientId: "",
    paymentType: "Card Payment",
    utilities: 0,
    housewares: 0,
    serviceFee: 0,
    totalAmount: "",
    cleaning: 0,
    monthlyRent: "",
    rent: "",
    fullStayAmount: "",
    originalValues: {},
    showTotalStay: false,
    totalStayAmount: "",
    invoiceList: [],
    newInvoiceList: [],
    termsCheck: false,
    companyName: "",
    totalStayDays: 0,
  });
  const mounted = React.useRef(true);

  const history = useHistory();

  const updateState = (newState) => {
    safeSetState(() => {
      setState((prev) => ({
        ...prev,
        ...newState,
      }));
    });
  };

  function handleError(err) {
    setState((prev) => ({ ...prev, loadingStatus: false }));

    console.log(err, "error");
  }

  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);

  const safeSetState = (callback) => {
    if (mounted.current) {
      callback();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    try {
      $(document).ready(function () {
        jQuery(function ($) {
          $("#phoneNo").intlTelInput();
        });
      });
      const savedState = localStorage.getItem("reserveState");
      let normalObject = JSON.parse(savedState);
      if (normalObject) {
        updateState({
          ...normalObject,
          checkin: normalObject.checkin,
          checkout: normalObject.checkout,
          monthlyRent: normalObject.monthlyRent,
          rent: normalObject.monthlyRent,
          communityData: normalObject.communities,
          loadingStatus: false,
        });

        // localStorage.removeItem("reserveState");
      }
    } catch (error) {
      handleError(error);
    }
  }, []);

  const backToPropertyDetails = () => {
    let data = state.communityData;
    if (data) {
      history.push(
        "/instant-booking-details/" +
          data.community_name.replace(/\/| /g, "-") +
          "-" +
          data.masterId
      );
    }
  };

  function validateEmailId(emailId) {
    try {
      const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      return emailPattern.test(emailId);
    } catch (err) {
      handleError(err);
    }
  }

  function validateNumber(number) {
    try {
      const numberPattern = /^\d{0,10}$/;
      return numberPattern.test(number);
    } catch (err) {
      handleError(err);
    }
  }

  function validatePhoneNumber(phoneNumber) {
    try {
      const phonePattern = /^\d{10}$/;
      return phonePattern.test(phoneNumber);
    } catch (err) {
      handleError(err);
    }
  }

  function setValue(field, event) {
    try {
      let value = event.target.value;
      if (field === "emailId") {
        validateEmailId(value)
          ? $("#" + field).removeClass("validation")
          : $("#" + field).addClass("validation");
        updateState({ [field]: value });
      } else if (field === "phoneNo") {
        validateNumber(value) && updateState({ [field]: value });
        validatePhoneNumber(value)
          ? $("#" + field).removeClass("validation")
          : $("#" + field).addClass("validation");
      }
      updateState({ [field]: value });
    } catch (err) {
      handleError(err);
    }
  }

  const validation = () => {
    let mandatoryFields = ["firstName", "lastName", "emailId", "phoneNo"];
    try {
      let errors = [];
      for (let field of mandatoryFields) {
        if (!state[field] || state[field].trim() === "") {
          $("#" + field).addClass("validation");
          errors.push(field);
        } else {
          $("#" + field).removeClass("validation");
        }
      }

      if (!state.emailId || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.emailId)) {
        console.log("hello");

        $("#emailId").addClass("validation");
        errors.push("emailId");
      } else {
        $("#emailId").removeClass("validation");
      }

      // Phone Number Validation using intlTelInput
      let phoneInput = $("#phoneNo");
      if (!validatePhoneNumber(state.phoneNo)) {
        phoneInput.addClass("validation");
        errors.push("phoneNo");
      } else {
        phoneInput.removeClass("validation");
      }

      return errors.length > 0 ? false : true;
    } catch (error) {
      handleError(error);
    }
  };

  const continueToBook = () => {
    let isValid = validation();
    if (isValid) {
      const countryCode =
        $(".country.highlight.active").attr("data-dial-code") == undefined
          ? "+1"
          : "+" + $(".country.highlight.active").attr("data-dial-code");
      const countrySymbol =
        $(".country.highlight.active").attr("data-country-code") == undefined
          ? "us"
          : $(".country.highlight.active").attr("data-country-code");
      // console.log(countryCode, "countryCode", countrySymbol);

      updateState({
        paymentMode: true,
        countryCode: countryCode,
        countrySymbol: countrySymbol,
      });
      window.scrollTo(0, 0);
    } else {
      updateState({ paymentMode: false });
    }
  };

  const bookingDetails = () => {
    updateState({ paymentMode: false });
  };

  useEffect(() => {
    $(document).ready(function () {
      jQuery(function ($) {
        $("#phoneNo").intlTelInput({
          initialCountry: state.countrySymbol,
        });
      });
    });
  }, [state.paymentMode]);

  const totalStayCalculation = () => {
    const { showTotalStay } = state;
    console.log(showTotalStay, "showTotalStay");

    if (!showTotalStay) {
      const {
        stayUtilitiesFee,
        stayHousewaresFee,
        stayServiceFee,
        totalStayAmount,
        totalAmount,
      } = stayCalulation(state);

      updateState({
        utilities: stayUtilitiesFee.toFixed(2),
        housewares: stayHousewaresFee.toFixed(2),
        serviceFee: stayServiceFee.toFixed(2),
        monthlyRent: totalStayAmount.toFixed(2),
        totalAmount: totalAmount.toFixed(2),
        showTotalStay: true,
      });
    }
  };

  const monthlyCalculation = () => {
    const { rent, utilities, cleaning, housewares, serviceFee, totalAmount } =
      calculateBookingPrices(state.communityData.suite, state.rent);
    console.log({
      rent,
      utilities,
      cleaning,
      housewares,
      serviceFee,
      totalAmount,
    });

    updateState({
      utilities,
      cleaning,
      housewares,
      serviceFee,
      totalAmount,
      showTotalStay: false,
      monthlyRent: rent,
    });
  };

  useEffect(() => {
    const calculatePrices = async () => {
      const { utilities, cleaning, housewares, serviceFee, totalAmount } =
        calculateBookingPrices(state.communityData.suite, state.rent);

      updateState({
        utilities,
        cleaning,
        housewares,
        serviceFee,
        totalAmount,
      });

      const { totalAmountLimit, totalAmountFull, stayDays } =
        totalFullStayAmount(state, utilities, housewares, serviceFee, cleaning);

      if (totalAmountLimit !== undefined && totalAmountFull !== undefined) {
        let response = await calculateTempInvoice(state, totalAmount);
        // console.log(response, "response");

        if (Array.isArray(response) && response.length > 0) {
          let mergingData = await mergeInvoicesByDaysLimit(response);
          // console.log(mergingData, "mergingData");
          updateState({
            newInvoiceList: mergingData,
          });
        }

        updateState({
          totalStayAmount: totalAmountLimit.toFixed(2),
          fullStayAmount: totalAmountFull.toFixed(2),
          totalStayDays: stayDays,
          invoiceList: response,
        });
      }
    };

    if (state.communityData) {
      calculatePrices();
    }
  }, [state.communityData]);

  return (
    <div className="SAweb_updateUi">
      <Header />
      <div className="property-info">
        <div className="container">
          <div className="row">
            {!state.paymentMode ? (
              <div className="col-md-7 col-lg-8 col-sm-6 brdr-right">
                <div className="backto">
                  <img
                    src="/assets/newUI-images/instantBook/back-arrow.svg"
                    alt=""
                    onClick={() => backToPropertyDetails()}
                  />
                  <span onClick={() => backToPropertyDetails()}>
                    View Property Info
                  </span>
                </div>
                <div className="guest-info">
                  <div className="title">
                    <h2>
                      <span>Guest Information</span>
                    </h2>
                  </div>
                  <form className="guest-form">
                    <div className="row">
                      <div className="col-md-11">
                        <div className="row">
                          <div className="form-group col-md-6 col-sm-12">
                            <label for="fname" className="form-label">
                              First Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="First Name *"
                              id="firstName"
                              value={state.firstName}
                              onChange={(e) => setValue("firstName", e)}
                            />
                          </div>
                          <div className="form-group col-md-6 col-sm-12">
                            <label for="lname" className="form-label">
                              Last Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="lastName"
                              placeholder="Last Name *"
                              value={state.lastName}
                              onChange={(e) => setValue("lastName", e)}
                            />
                          </div>
                          <div className="form-group col-md-6 col-sm-12">
                            <label for="emailaddr" className="form-label">
                              Email Address
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="emailId"
                              placeholder="Email *"
                              value={state.emailId}
                              onChange={(e) => setValue("emailId", e)}
                            />
                          </div>
                          <div className="form-group col-md-6 col-sm-12">
                            <label for="phone" className="form-label">
                              Phone
                            </label>
                            <input
                              type="text"
                              id="phoneNo"
                              className="form-control"
                              placeholder="Phone Number*"
                              maxLength="10"
                              onChange={(e) => setValue("phoneNo", e)}
                              onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              onBlur={(e) => setValue("phoneNo", e)}
                              value={state.phoneNo}
                            />
                          </div>
                          <div className="form-group col-md-6 col-sm-12">
                            <label for="cname" className="form-label">
                              Company Name (Optional)
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Company Name"
                              id="companyName"
                              value={state.companyName}
                              onChange={(e) => setValue("companyName", e)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="guest-info review-pay">
                  <div className="title">
                    <h2>
                      <span>Payment Information</span>
                    </h2>
                    <p>You're just one step away from reserving your stay.</p>
                  </div>

                  {/* <form
                    role="form"
                    method="post"
                    className="payment-form guest-form"
                  >
                    <div className="row">
                      <div className="col-md-12 col-lg-6">
                        <div className="form-group ">
                          <label for="emailaddr" className="form-label">
                            Email{" "}
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="JackSullivan@gmail.com"
                          />
                        </div>

                        <div className="form-group ">
                          <label for="cinfo" className="form-label">
                            Card information
                          </label>
                          <div className="input-addon">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="0000 0000 0000 0000"
                            />
                            <img
                              src="/assets/newUI-images/instantBook/mastercard.svg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group ">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="MM/YY"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group ">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="CVC"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="form-group ">
                          <label for="ncard" className="form-label">
                            Name on card{" "}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                          />
                        </div>
                        <div className="form-group ">
                          <label for="country" className="form-label">
                            Country or region
                          </label>
                          <select className="form-control form-select">
                            <option>+1 (555) 000-0000</option>
                            <option>+1 (555) 000-0000</option>
                            <option>+1 (555) 000-0000</option>
                            <option>+1 (555) 000-0000</option>
                          </select>
                        </div>

                        <div className="form-group">
                          <button className="btn btn-continue w-100" type="button">
                            Pay $350.00
                          </button>
                        </div>
                        <p className="byclick ">
                          By clicking “Pay Now,” you authorize SuiteAmerica to
                          charge your selected payment method for the total
                          amount and store your details securely via Stripe.
                        </p>
                      </div>
                    </div>
                  </form> */}

                  <Elements stripe={stripePromise}>
                    <PayMentForm
                      state={state}
                      updateState={updateState}
                      setValue={setValue}
                    />
                  </Elements>
                  <div className="accept-card">
                    <div className="card-info">
                      <img
                        src="/assets/newUI-images/instantBook/lock.svg"
                        alt=""
                      />
                      <p>
                        <span>We accept all major credit and debit cards.</span>
                        <span>
                          {" "}
                          Your payment information is encrypted and processed
                          securely via Stripe.
                        </span>
                      </p>
                    </div>
                  </div>
                  <p className="guest-terms">
                    By booking, you agree to our Guest Terms and Payment Policy.
                    Your reservation will be finalized upon your background
                    check.
                  </p>
                  {/* <button
                    className="btn btn-continue"
                    onClick={() => continueToBook()}
                  >
                    Continue to Book
                  </button> */}
                </div>
              </div>
            ) : (
              <div className="col-md-7 col-lg-8 brdr-right">
                <div className="backto">
                  <img
                    src="/assets/newUI-images/instantBook/back-arrow.svg"
                    alt=""
                    onClick={() => bookingDetails()}
                  />
                  <span onClick={() => bookingDetails()}>Booking Details</span>
                </div>
                <div className="guest-info">
                  <div className="title">
                    <h2>
                      <span>Secure Payment</span>
                    </h2>
                  </div>
                  <form
                    role="form"
                    method="post"
                    className="payment-form guest-form"
                  >
                    <div className="row">
                      <div className="col-md-12 col-lg-6">
                        <div className="form-group ">
                          <label for="emailaddr" className="form-label">
                            Email{" "}
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="JackSullivan@gmail.com"
                          />
                        </div>

                        <div className="form-group ">
                          <label for="cinfo" className="form-label">
                            Card information
                          </label>
                          <div className="input-addon">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="0000 0000 0000 0000"
                            />
                            <img
                              src="/assets/newUI-images/instantBook/mastercard.svg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group ">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="MM/YY"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group ">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="CVC"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="form-group ">
                          <label for="ncard" className="form-label">
                            Name on card{" "}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                          />
                        </div>
                        <div className="form-group ">
                          <label for="country" className="form-label">
                            Country or region
                          </label>
                          <select className="form-control form-select">
                            <option>+1 (555) 000-0000</option>
                            <option>+1 (555) 000-0000</option>
                            <option>+1 (555) 000-0000</option>
                            <option>+1 (555) 000-0000</option>
                          </select>
                        </div>

                        <div className="form-group">
                          <button
                            className="btn btn-continue w-100"
                            type="button"
                          >
                            Pay $350.00
                          </button>
                        </div>
                        <p className="byclick ">
                          By clicking “Pay Now,” you authorize SuiteAmerica to
                          charge your selected payment method for the total
                          amount and store your details securely via Stripe.
                        </p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              // <Elements stripe={stripePromise}>
              //   <PayMentForm state={state} updateState={updateState} />
              // </Elements>
            )}

            <div className="col-md-5 col-lg-4 col-sm-6 mobile-card-gap">
              <div className=" guest-right">
                <div className="guest-img">
                  <figure>
                    <img src={state.communityData.banner_image} alt="" />
                  </figure>
                  <div className="hotel-title">
                    <h4>{state.communityData.community_name}</h4>
                    <p style={{ textTransform: "capitalize" }}>
                      {state.communityData.address},
                      {" " + state.communityData?.city_name?.toLowerCase()}
                    </p>
                  </div>
                  <div className="hotel-amenity">
                    <ul>
                      <li>
                        <span>
                          <img
                            src="/assets/newUI-images/instantBook/single-bed.svg"
                            alt=""
                          />
                        </span>
                        <span>{state.communityData.bedrooms} Bedroom</span>
                      </li>
                      {state.communityData.bathrooms != "" &&
                        state.communityData.bathrooms != null && (
                          <li>
                            <span>
                              <img
                                src="/assets/newUI-images/instantBook/tub.svg"
                                alt=""
                              />
                            </span>
                            <span>
                              {state.communityData.bathrooms} Bathroom
                            </span>
                          </li>
                        )}
                    </ul>
                  </div>
                  <p className="booked-date">
                    {" "}
                    {state.checkin
                      ? moment(state.checkin).format("MMMM D, YYYY")
                      : ""}{" "}
                    |{" "}
                    {state.checkout
                      ? moment(state.checkout).format("MMMM D, YYYY")
                      : ""}
                  </p>

                  <div className="pricingSwitch">
                    <button
                      className={`btn black-btn my-4 ${
                        !state.showTotalStay ? "active" : ""
                      }`}
                      onClick={() => monthlyCalculation()}
                    >
                      Monthly Cost
                    </button>
                    <button
                      className={`btn black-btn my-4 ${
                        state.showTotalStay ? "active" : ""
                      }`}
                      onClick={() => totalStayCalculation()}
                    >
                      Total Cost
                    </button>
                  </div>
                  <div className="pricing-down">
                    {state.showTotalStay ? (
                      <h3> Total Stay Pricing Breakdown</h3>
                    ) : (
                      <h3>Monthly Pricing Breakdown</h3>
                    )}
                    {/* <label className="switch">
                        <input type="checkbox" />
                        <span
                          className="slider round"
                          onClick={() => totalStayCalculation()}
                        ></span>
                      </label> */}

                    <hr />
                    <ul className="payment-item">
                      <li>
                        {state.showTotalStay ? (
                          <span>Total Rent</span>
                        ) : (
                          <span>Monthly Rent</span>
                        )}
                        <span>${Number(state.monthlyRent).toFixed(2)}</span>
                      </li>
                      <li>
                        <span>
                          Utilities{" "}
                          <Tooltip title="Water, Trash, Power and Internet">
                            <i className="bi bi-info-circle cursor-pointer pl-2"></i>
                          </Tooltip>
                        </span>
                        <span> ${state.utilities}</span>
                      </li>

                      <li>
                        <span> Housewares & Linens Fee </span>
                        <span> ${state.housewares}</span>
                      </li>
                      <li>
                        <span> Service fee</span>
                        <span>${state.serviceFee}</span>
                      </li>
                      {state.showTotalStay && (
                        <li>
                          <span>
                            {" "}
                            Move Out Cleaning Fee (One time)
                            <Tooltip title="This is a one time cleaning fee that will be charged closer to check out date">
                              <i className="bi bi-info-circle cursor-pointer pl-2"></i>
                            </Tooltip>{" "}
                          </span>
                          <span> ${state.cleaning}</span>
                        </li>
                      )}
                    </ul>
                    <hr />
                    <ul className="payment-item">
                      <li className="total">
                        {state.showTotalStay ? (
                          <span>Total</span>
                        ) : (
                          <span>Monthly Total</span>
                        )}
                        <span>${state.totalAmount}</span>
                      </li>
                      {!state.showTotalStay && (
                        <li>
                          <span>
                            {" "}
                            Move Out Cleaning Fee (One time)
                            <Tooltip title="This is a one time cleaning fee that will be charged closer to check out date">
                              <i className="bi bi-info-circle cursor-pointer pl-2"></i>
                            </Tooltip>{" "}
                          </span>
                          <span> ${state.cleaning}</span>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
                <div className="guest-img pricing-down paymentSchedule">
                  <h3>Payment Schedule</h3>
                  <hr />
                  <ul className="payment-item">
                    {state?.invoiceList?.length > 0 ? (
                      state.newInvoiceList.map((data, index) => {
                        const isLastItem =
                          index === state.newInvoiceList.length - 1;
                        const lastItem =
                          state.newInvoiceList[state.newInvoiceList.length - 1];

                        // const from = moment(data.InvoiceFromDate).format(
                        //   "MMM DD"
                        // );
                        // const to = moment(data.InvoiceToDate).format("MMM DD");
                        return (
                          <React.Fragment key={index}>
                            <li>
                              <>
                                <span>
                                  <span>
                                    {data.from} - {data.to}
                                  </span>
                                  <span>
                                    ${Number(data.InvoiceAmount).toFixed(2)}
                                  </span>
                                </span>

                                <span className="lightclr">
                                  {data.InvoiceNote}
                                </span>
                              </>
                            </li>

                            {isLastItem && (
                              <li>
                                <span>
                                  <span> Move Out Cleaning Fee (One time)</span>
                                  <span>${state.cleaning}</span>
                                </span>

                                <span className="lightclr">
                                  {lastItem.totalDays <= 30 ? (
                                    "Due On Booking"
                                  ) : (
                                    <>
                                      Due{" "}
                                      {moment(lastItem.from)
                                        .subtract(7, "days")
                                        .format("MMM DD")}
                                    </>
                                  )}
                                </span>
                              </li>
                            )}
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <li>No invoice data available</li>
                    )}

                    {/* <li>
                      <span>May 31 -Jun30</span>{" "}
                      <span className="lightclr">Due May 24</span>
                      <span>$0000.00</span>
                    </li>
                    <hr />
                    <li>
                      <span>Jun 30 -Jul 31</span>{" "}
                      <span className="lightclr">Due Jun23</span>
                      <span>$0000.00</span>
                    </li> */}
                  </ul>
                </div>
                <div className="gray-box">
                  <figure>
                    <img
                      src="/assets/newUI-images/instantBook/tick-circle.svg"
                      alt=""
                    />
                  </figure>
                  <div className="box-title">
                    <h3>Instant Confirmation</h3>
                    <p>
                      Once you complete your reservation, you’ll receive instant
                      confirmation. Your booking is guaranteed and secured
                      immediately.
                    </p>
                  </div>
                </div>
                <div className="gray-box">
                  <figure>
                    <img
                      src="/assets/newUI-images/instantBook/hidden-fee.svg"
                      alt=""
                    />
                  </figure>
                  <div className="box-title">
                    <h3>No Hidden Fees</h3>
                    <p>
                      {" "}
                      The price you see is the price you pay—no surprise
                      charges.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NewInstantReserveBook;
